import { createFileRoute } from '@tanstack/react-router'
import { GeneralTab } from '@/pages/donor-detail/ui/GeneralTab'

function GeneralTabRoute() {
  const { visitId } = Route.useParams()
  return <GeneralTab visitId={visitId} canOverrideDeferral />
}

export const Route = createFileRoute('/_protected/donors/$visitId/')({
  component: GeneralTabRoute,
})
